import React from 'react';
import {Link} from 'react-router-dom';

type SupportItemsProps = {
    requestItems: RequestItem[];
};

export type RequestItem = {
    summary: string;
    type: string;
    requestNumber: string;
    requestDate: string;
};

export const SupportItems: React.FunctionComponent<SupportItemsProps> = ({
                                                                             requestItems
                                                                         }): JSX.Element => {
    return (
        <div className="list-group list-group-flush">
            {requestItems.map((requestItem: RequestItem) => (
                <Link to={`/entry/${requestItem.requestNumber}`}
                      className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between align-items-center text-muted">
                        <div className="flex-grow-1">{requestItem.summary}</div>
                        {requestItem?.type && <small className="text-primary">{requestItem.type}</small>}
                    </div>
                    <div className="d-flex w-100 justify-content-between text-muted">
                        <small>#{requestItem.requestNumber}</small>
                        <small>{requestItem.requestDate}</small>
                    </div>
                </Link>
            ))}
        </div>
    );
};